var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.46 2.21191C20.69 2.56191 19.86 2.79191 19 2.90191C19.88 2.37191 20.56 1.53191 20.88 0.521914C20.05 1.02191 19.13 1.37191 18.16 1.57191C17.37 0.711914 16.26 0.211914 15 0.211914C12.65 0.211914 10.73 2.13191 10.73 4.50191C10.73 4.84191 10.77 5.17191 10.84 5.48191C7.28004 5.30191 4.11004 3.59191 2.00004 1.00191C1.63004 1.63191 1.42004 2.37191 1.42004 3.15191C1.42004 4.64191 2.17004 5.96191 3.33004 6.71191C2.62004 6.71191 1.96004 6.51191 1.38004 6.21191V6.24191C1.38004 8.32191 2.86004 10.0619 4.82004 10.4519C4.19077 10.6241 3.53013 10.6481 2.89004 10.5219C3.16165 11.3744 3.69358 12.1203 4.41106 12.6548C5.12854 13.1894 5.99549 13.4856 6.89004 13.5019C5.37367 14.7024 3.49404 15.3512 1.56004 15.3419C1.22004 15.3419 0.880039 15.3219 0.540039 15.2819C2.44004 16.5019 4.70004 17.2119 7.12004 17.2119C15 17.2119 19.33 10.6719 19.33 5.00191C19.33 4.81191 19.33 4.63191 19.32 4.44191C20.16 3.84191 20.88 3.08191 21.46 2.21191Z",
    fill: "#423F3F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b40c0bb6ea3cb7b4c40d5f667ef7f71e.svg";
export { ForwardRef as ReactComponent };